/**
 * The async variant of the Array.filter() method that
 * @param values An iterable of elements to filter
 * @param callbackFn The async callback that will be executed on the elements
 * @returns Promise<T[]>
 */
export const filterAsync = async (values, callbackFn) => {
  const returns = [];

  for (const value of values) {
    ;
    (await callbackFn(value)) && returns.push(value);
  }

  return returns;
};
;

Array.prototype.filterAsync = function (callbackFn) {
  return filterAsync(this, callbackFn);
};
//# sourceMappingURL=filter-async.js.map